module.exports = __webpack_public_path__ + "static/media/web-background-version-3.c554dc9a.png";